import { LookupModel } from '../../../../../api/models';
import { YealinkExpansionModel, PolycomExpansionModel } from '../enums';

export const YEALINK_EXPANSION_OPTIONS: LookupModel[] = [
  ...Object.entries(YealinkExpansionModel).map(([id, label]) => ({
    id,
    text: label,
  })),
];

export const POLYCOM_EXPANSION_OPTIONS: LookupModel[] = [
  ...Object.entries(PolycomExpansionModel).map(([id, label]) => ({
    id,
    text: label,
  })),
];
